import { ReactComponent as WeCheckIcon } from '@assets/wc-logo-inline.svg';
import {
  Center,
  Flex,
  Heading,
  Icon,
  Link,
  Text,
  VStack,
} from '@chakra-ui/react';
import React from 'react';
import { BiError } from 'react-icons/bi';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

const Footer = () => {
  const { t } = useTranslation();
  return (
    <Flex
      w="full"
      borderTopWidth="thin"
      bg="white"
      alignSelf="flex-end"
      h="20"
      p="4"
      alignItems="center"
      justifyContent="center"
    >
      <Text fontWeight="bold">{t('request_invalid.powered_by')}</Text>
      <Link href="https://wecheckapp.com.br/" isExternal>
        <WeCheckIcon width="auto" height="50px" />
      </Link>
    </Flex>
  );
};

function useSearchParams() {
  const location = useLocation();
  return React.useMemo(() => new URLSearchParams(location.search), [location]);
}

export function RequestInvalid() {
  const { t } = useTranslation();
  const searchParams = useSearchParams();

  const responseMessage = searchParams.get('message');

  if (responseMessage) {
    window.history.replaceState({}, '', '/request-invalid');
  }

  return (
    <VStack flex="1">
      <Center flex={1} w="full">
        <VStack>
          <Icon as={BiError} fontSize={90} color="gray.600" />
          <Heading size="2xl" color="gray.600">
            {responseMessage || t('request_invalid.invalid_request')}
          </Heading>
        </VStack>
      </Center>
      <Footer />
    </VStack>
  );
}
